import { BrowserRouter,Route,Routes} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import Home from './Vistas/Home';
import Principal from './Vistas/Principal';
//import Herramientas from './Componentes/Catalogos/CategoriaHerramientas/Herramientas'
import Login from './Vistas/Login';
//import TablaHerramientas from './Componentes/Herramientas/TablaHerramientas';
//import Users from './Utils/Users';
import Categorias from './Componentes/Catalogos/CategoriasMateriales/Categorias';
import TablaMaterial from './Componentes/Materiales/TablaMaterial';
import TipObras from './Componentes/Catalogos/TipObras/TiposObra';
import TablaObras from './Componentes/Obras/TablaObras';
import TablaEntrada from './Componentes/AdministracionObras/AdmonMateriales/TablaEntrada';
import TablaUnidad from './Componentes/Catalogos/Unidades/TablaUnidad';
import Obras from './Componentes/AdministracionObras/Obras';
import AdministracionObra from './Componentes/AdministracionObras/AdministracionObra';
import AdmonHerramientas from './Componentes/AdministracionObras/AdmonHerramientas/Herramientas';
import SalidaHerramientas from './Componentes/AdministracionObras/AdmonHerramientas/SalidaHerramienta';
import EntradaHerramientas from './Componentes/AdministracionObras/AdmonHerramientas/EntradaHerramienta';
import AdmonMateriales from './Componentes/AdministracionObras/AdmonMateriales/Materiales';
import TablaSalida from './Componentes/AdministracionObras/AdmonMateriales/TablaSalida';
//import TablaPrestamos from './Componentes/Prestamos/TablaPrestamos';
import ManoObra from './Componentes/AdministracionObras/AdmonManoObra/ManoObra';
import AsistenciaObra from './Componentes/AdministracionObras/AdmonAsistenciaObra/AsistenciaObra';
import TablaBodegas from './Componentes/Catalogos/Bodegas/TablaBodegas';
import Areas from './Componentes/Catalogos/Areas/Areas';
import Puestos from './Componentes/Catalogos/Puestos/Puestos';
import GastosManoObra from './Componentes/AdministracionObras/AdmonGastosManoObra/GastosManoObra';
import TablaAsisOficina from './Componentes/AdmonOficina/TablaAsisOficina';
import GastoMaterial from './Componentes/AdministracionObras/AdmonGastosMateriales/GastoMaterial';
import Catalogos from './Componentes/Catalogos/Catalogos';
import Adicionales from './Componentes/Catalogos/Adicionales/Adicionales';
import Maquinaria from './Componentes/Catalogos/Maquinaria&Equipo/MaquinariaEquipo';
import Tramites from './Componentes/Catalogos/Tramites/Tramites';
import GastosAdicionalesObra from './Componentes/AdministracionObras/AdmonGastosAdicionales/GastosAdicionales';
import GastosMaquinariaObra from './Componentes/AdministracionObras/AdmonGastosMaquinaria/GastosMaquinaria';
import GastosTramitesObra from './Componentes/AdministracionObras/AdmonGastosTramites/GastosTramites';
import AdmonAsisOfis from './Componentes/AdmonOficina/AdmonAsisOfis';
import PagosOficina from './Componentes/AdmonOficina/PagosOficina';
import GastosOficina from './Componentes/AdmonOficina/GastosOficina';
import PagosCampo from './Componentes/AdmonOficina/PagosCampo';

//import TablaIngreso from './Componentes/Ingresos/TablaIngreso';
import PrivateRoute from './Utils/PrivateRoutes';
import Usuarios from './Componentes/Catalogos/Usuarios/Usuarios';
import Proyectos from './Componentes/Proyectos/Proyectos';
import TablaProyectos from './Componentes/Catalogos/ProyectosGestion/TablaProyectos';
// import ObrasHome from './Componentes/Usuarios/ObrasScreen';
// import MainScreen from './Componentes/Usuarios/MainScreen';
// import AdmonObra from './Componentes/Usuarios/Obras/AdmonObra';
// import AsisObra from './Componentes/Usuarios/Obras/AsisObra';
import Actividades from './Componentes/Catalogos/Actividades/Actividades';
import SubActividades from './Componentes/Catalogos/Actividades/SubActividades';
import ThirdSubCat from './Componentes/Catalogos/Actividades/ThirdSubCat';
import ObrasUsuarios from './Componentes/Catalogos/ObrasUsuarios/TablaRoles';
import ObraActividades from './Componentes/AdministracionObras/AdmonActividades/ObraActividades';
import Permisos from './Componentes/Catalogos/Usuarios/Permisos';
import IndexEmpleados from './Componentes/Empleados/IndexEmpleados';
import EmpleadosCampo from './Componentes/Empleados/EmpleadosCampo';
import EmpleadosOficina from './Componentes/Empleados/EmpleadosOficina';
import Bitacora from './Componentes/AdministracionObras/AdmonBitacora/Bitacora';
//import ResetPassword from './Vistas/ResetPassword';
import Contabilidad from './Componentes/Contabilidad/Contabilidad';
import ContabilidadProyectos from './Componentes/Contabilidad/Proyectos/ContabilidadProyectos';
import ContabilidadInmobiliaria from './Componentes/Contabilidad/Proyectos/ContabilidadInmobiliaria';

function App() {
    /*window.addEventListener("beforeunload", (ev) => 
        {  
            ev.preventDefault();
            return ev.returnValue = 'Are you sure you want to close?';
        });*/
    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<Login/>} />
                {/*<Route path='TLRRFXV4/' element={<Users />} />*/}
                {/*<Route path='forgot-password/' element={<ResetPassword />} />*/}
                <Route element={<PrivateRoute />}>
                    {/*<Route exact path='Dashboard/*' element={<ObrasHome />}>
                        <Route index element={<MainScreen />} />
                        <Route path='Admon' element={<AdmonObra />} />
                        <Route path='Admon/Asistencia-Obra' element={<AsisObra />} />
                    </Route>*/}
                    <Route exact path='inicio/*' element={ <Home />} >
                        <Route index element={<Principal />}/>
                        {/*RUTAS CATALAGOS*/}
                        <Route path='Catalogos' element={<Catalogos />} />
                        <Route path='Catalogos/Actividades' element={<Actividades />} />
                        <Route path='Catalogos/Actividades/SubActividades' element={<SubActividades />} />
                        <Route path='Catalogos/Actividades/SubActividades/NivTrActividades' element={<ThirdSubCat />} />
                        <Route path='Catalogos/Adicionales' element={<Adicionales />} />
                        <Route path='Catalogos/Tramites' element={<Tramites />} />
                        <Route path='Catalogos/Usuarios' element={<Usuarios />} />
                        <Route path='Catalogos/Usuarios/Permisos' element={<Permisos/>} />
                        <Route path='Catalogos/Tabla-Proyectos' element={<TablaProyectos />} />
                        <Route path='Catalogos/Maquinaria-Equipo' element={<Maquinaria />} />
                        <Route path='Catalogos/Obras-Usuarios' element={<ObrasUsuarios />} />
                        <Route path='Catalogos/Bodegas' element={<TablaBodegas />} />
                        <Route path='Catalogos/Tipos-Obras' element={<TipObras />} />
                        <Route path='Catalogos/Unidades' element={<TablaUnidad />} />
                        <Route path='Catalogos/Empleados' element={<IndexEmpleados />} />
                        <Route path='Catalogos/Empleados/Campo' element={<EmpleadosCampo />} />
                        <Route path='Catalogos/Empleados/Oficina' element={<EmpleadosOficina />} />
                        <Route path='Catalogos/Areas' element={<Areas />} />
                        <Route path='Catalogos/Puestos' element={<Puestos />} />
                        <Route path='Catalogos/Obras' element={<TablaObras />} />
                        <Route path='Catalogos/Materiales' element={<Categorias />} />
                        <Route path='Catalogos/Materiales/Tabla-Materiales' element={<TablaMaterial />} />
                        {/*<Route path='Catalogos/Herramientas' element={<Herramientas />} />*/}
                        {/*<Route path='Catalogos/Herramientas/Tabla-Herramientas' element={<TablaHerramientas />} />*/}
                        {/*RUTAS CATALOGOS*/}

                        {/*RUTAS PROYECTOS*/}
                        <Route path='Proyectos' element={<Proyectos />} />
                        <Route path='Proyectos/Lista-Obras' element={<Obras />} />
                        <Route path='Proyectos/Administracion-Obras' element={<AdministracionObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras' element={<AdministracionObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Mano-Obra' element={<ManoObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Herramientas/' element={<AdmonHerramientas />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Herramientas/Salida-Herramientas' element={<SalidaHerramientas />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Herramientas/Entrada-Herramientas' element={<EntradaHerramientas />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Materiales' element={<TablaEntrada /> /* <AdmonMateriales /> */} />
                        {/* <Route path='Proyectos/Lista-Obras/Administracion-Obras/Materiales/TablaEntrada' element={<TablaEntrada />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Materiales/TablaSalida' element={<TablaSalida />} /> */}
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Asistencia-Obra' element={<AsistenciaObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Gastos-Mano-Obra' element={<GastosManoObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Gastos-Adicionales' element={<GastosAdicionalesObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Gastos-Maquinaria' element={<GastosMaquinariaObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Gastos-Tramites' element={<GastosTramitesObra />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Gastos-materiales' element={<GastoMaterial />} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Actividad-Obra' element={<ObraActividades/>} />
                        <Route path='Proyectos/Lista-Obras/Administracion-Obras/Bitacora' element={<Bitacora/>} />
                        {/*RUTAS PROYECTOS*/}
     
                        {/*
                        <Route path='Prestamos' element={<TablaPrestamos />} />

                         <Route path='Ingresos' element={<TablaIngreso />} />
                       */}
                        <Route path='Oficina' element={<AdmonAsisOfis />} />
                        <Route path='Oficina/AsisOficina' element={<TablaAsisOficina />} />
                        <Route path='Oficina/PagosOficina' element={<PagosOficina />} />
                        <Route path='Oficina/GastosOficina' element={<GastosOficina />} />
                        <Route path='Oficina/PagosCampo' element={<PagosCampo />} />

                       
                        <Route path='Contabilidad' element={<Contabilidad />} />
                        <Route path='Contabilidad/Proyectos' element={<ContabilidadProyectos />} />
                        <Route path='Contabilidad/Inmobiliaria' element={<ContabilidadInmobiliaria />} />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;